import React from 'react'
import {
    Toolbar,
} from '@mui/material'

import Home from './../../components/home/home.js'
import About from './../../components/about/about.js'
import Experience from './../../components/experience/experience.js'
import Skills from './../../components/skills/skills.js'
import Contacts from './../../components/contacts/contacts.js'

const Main = () => <React.Fragment>
    <div id='Home'></div>
    <Home />

    <div id='About'></div>
    <Toolbar />
    <Toolbar />
    <About />

    <div id='Experience'></div>
    <Toolbar />
    <Toolbar />
    <Experience />

    <div id='Skills'></div>
    <Toolbar />
    <Toolbar />
    <Skills />

    <div id='Contact'></div>
    <Toolbar />
    <Toolbar />
    <Contacts />

    <Toolbar />
</React.Fragment>

export default Main